// extracted by mini-css-extract-plugin
export default {"app":"L5x0Fp","scrollable":"aVF3iR","postPageApp":"Led6wX","post-page--split":"ZLZ7oD","postPageSplit":"ZLZ7oD"};